<template>
  <div class="newss">
    <div class="header" style="height: 62px;background: #292e41;">
      <div class="logo" style="float: left; margin: 14px 0 10px 80px;height: 32px;">
        <img src="../assets/images/midea.png" alt="" style="width: 81px;height: 29px;">
      </div>
    </div>
    <div class="news" style="background-color: #fff;padding: 30px;">
      <div style="margin-bottom: 21px;">
        <h3 style="text-align: left;font-size: 18px;">{{keyword}}</h3>
      </div>
      <div class="tag-content" @touchmove="loadArticleList()" @mousewheel="loadArticleList()">
        <div class="content-item" v-for="item in articleList" :key="item.id" @click="getArticleDetail(item.submsgs[0])">
          <div style="display: flex;padding-top: 16px;">
            <div class="tupian" style="padding-right: 12px;display: flex;justify-content: center;align-items: center;">
              <img :src="item.submsgs[0].coverImg" alt="" style="width: 128px;height: 72px;">
            </div>
            <div class="wenzi">
              <h4 style="color: #333;font-weight: 600;font-size: 16px;">{{item.submsgs[0].title}}</h4>
              <h5 style="font-size: 14px;color: #333;line-height: 20px;margin-top: 4px;">{{item.submsgs[0].summary}}</h5>
              <h6 style="font-size: 12px;color: #6C7880;margin-top: 9px;margin-bottom: 16px;">
                <span style="margin-right: 8px;">{{item.submsgs[0].author}}</span>
                <span style="margin-right: 16px;">{{item.submsgs[0].createTime | showWeekday }}</span>
                <img src="../assets/images/readNum.png" alt="" style="width: 16px;height: 11px;margin-right: 4px;font-size: 18px;font-weight: 500;">
                <span style="font-size: 12px;margin-right: 4px;color: rgb(130, 140, 155);">{{item.submsgs[0].readednum || 0}}</span>
                <img src="../assets/images/comment.png" alt="" style="width: 16px;height: 11px;margin-right: 4px;font-size: 18px;font-weight: 500;">
                <span style="font-size: 12px;margin-right: 4px;color: rgb(130, 140, 155);">{{item.submsgs[0].commentnum || 0}}</span>
              </h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { tagMixin } from '../mixins/tag'
export default {
  name: 'news',
  mixins: [tagMixin]
}
</script>

<style scoped>
  .news {
    margin: 0 auto;
    min-width: 750px;
    max-width: 960px;
  }
  .content-item {
    border-top: 1px solid #e0e2e7;
  }
  .content-item:hover {
    background-color: #F3F4F5;
    cursor: pointer;
  }
</style>
